import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Text from 'components/common/Text'

const EmptyImageContainer = styled.div`
  width: 100%;
  height: 100%;
  border: 2px gray dashed;
  display: flex;
  justify-content: center;
  align-items: center;
`
const ImagePreview = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 51;
  background-color: black;
`

class BackgroundImage extends Component {

  render () {
    const { slideId, imageUrl } = this.props
    // console.log('render background image', imageUrl)
    const idx = 0
    if (imageUrl) {
      return (
        <div className='ou_showcase__image-container'>
          <ImagePreview id='ou_showcase-image-preview' style={{display: 'none'}} />
          <div
            id={`ou_showcase__image${idx}`}
            style={{backgroundImage: `url(${imageUrl})`}}
            className={`ou_showcase__image ou_showcase_${idx}_image ou_showcase_${slideId}_image_p js-scroll-x`}
          />
        </div>
      )
    } else {
      return (
        <div className='ou_showcase__image-container'>
          <EmptyImageContainer>
            <Text
              color='gray'
              stylesRaw='font-style: italic; cursor: default; user-select: none; font-size: 4rem'
            >
              Background image
            </Text>
          </EmptyImageContainer>
        </div>
      )
    }
  }

}


BackgroundImage.propTypes = {
  slideId: PropTypes.string.isRequired,
  imageUrl: PropTypes.string
}

export default BackgroundImage



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/productsSlideWizard/BackgroundImage.js